const iceCream = [
    {
        id: 1,
        category: '초콜릿',
        name: '초콜릿 무스',
        img: process.env.PUBLIC_URL + '/images/ice_cream01.png',
    },
    {
        id: 2,
        category: '디저트',
        name: '아이스 꼬북칩',
        img: process.env.PUBLIC_URL + '/images/ice_cream02.png',
    },
    {
        id: 3,
        category: '치즈 / 크림',
        name: '바람과 함께 사라지다',
        img: process.env.PUBLIC_URL + '/images/ice_cream03.png',
    },
    {
        id: 4,
        category: '초콜릿',
        name: '초콜릿 쿠키 스모어',
        img: process.env.PUBLIC_URL + '/images/ice_cream04.png',
    },
    {
        id: 5,
        category: '디저트',
        name: '밤이 옥수로 맛있구마',
        img: process.env.PUBLIC_URL + '/images/ice_cream05.png',
    },
    {
        id: 6,
        category: '디저트',
        name: '쫀떡 만난 흑임자',
        img: process.env.PUBLIC_URL + '/images/ice_cream06.png',
    },
    {
        id: 7,
        category: '디저트',
        name: '진정한 쫀꾸렛',
        img: process.env.PUBLIC_URL + '/images/ice_cream07.png',
    },
    {
        id: 8,
        category: '디저트',
        name: '아이스 호떡',
        img: process.env.PUBLIC_URL + '/images/ice_cream08.png',
    },
    {
        id: 9,
        category: '과일',
        name: '베리 굿',
        img: process.env.PUBLIC_URL + '/images/ice_cream09.png',
    },
    {
        id: 10,
        category: '디저트',
        name: '말랑 꿀떡 모찌',
        img: process.env.PUBLIC_URL + '/images/ice_cream10.png',
    },
    {
        id: 11,
        category: '샤베트 / 요거트',
        name: '레인보우 샤베트',
        img: process.env.PUBLIC_URL + '/images/ice_cream11.png',
    },
    {
        id: 12,
        category: '초콜릿',
        name: '(Lessly Edition) 엄마는 외계인',
        img: process.env.PUBLIC_URL + '/images/ice_cream12.png',
    },
    {
        id: 13,
        category: '과일',
        name: '수박 Hero',
        img: process.env.PUBLIC_URL + '/images/ice_cream13.png',
    },
    {
        id: 14,
        category: '치즈 / 크림',
        name: '치즈 고구마구마',
        img: process.env.PUBLIC_URL + '/images/ice_cream14.png',
    },
    {
        id: 15,
        category: '치즈 / 크림',
        name: '뉴욕 치즈케이크',
        img: process.env.PUBLIC_URL + '/images/ice_cream15.png',
    },
    {
        id: 16,
        category: '초콜릿',
        name: '엄마는 외계인',
        img: process.env.PUBLIC_URL + '/images/ice_cream16.png',
    },
    {
        id: 17,
        category: '견과 / 커피 / 티',
        name: '소금 우유 아이스크림',
        img: process.env.PUBLIC_URL + '/images/ice_cream17.png',
    },
    {
        id: 18,
        category: '초콜릿',
        name: '오레오 쿠키 앤 크림',
        img: process.env.PUBLIC_URL + '/images/ice_cream18.png',
    },
    {
        id: 19,
        category: '디저트',
        name: '슈팅스타',
        img: process.env.PUBLIC_URL + '/images/ice_cream19.png',
    },
    {
        id: 20,
        category: '과일',
        name: '아빠는 딸바봉',
        img: process.env.PUBLIC_URL + '/images/ice_cream20.png',
    },
    {
        id: 21,
        category: '초콜릿',
        name: '윈터 민트 초콜릿 칩',
        img: process.env.PUBLIC_URL + '/images/ice_cream21.png',
    },
    {
        id: 22,
        category: '견과 / 커피 / 티',
        name: '너 T(tea)야??',
        img: process.env.PUBLIC_URL + '/images/ice_cream22.png',
    },
    {
        id: 23,
        category: '치즈 / 크림',
        name: '크림치즈 피치 타르트',
        img: process.env.PUBLIC_URL + '/images/ice_cream23.png',
    },
    {
        id: 24,
        category: '초콜릿',
        name: '(Lessly Edition) 아몬드 봉봉',
        img: process.env.PUBLIC_URL + '/images/ice_cream24.png',
    },
    {
        id: 25,
        category: '과일',
        name: '베리베리 스트로베리',
        img: process.env.PUBLIC_URL + '/images/ice_cream25.png',
    },
    {
        id: 26,
        category: '과일',
        name: '체리쥬빌레',
        img: process.env.PUBLIC_URL + '/images/ice_cream26.png',
    },
    {
        id: 27,
        category: '초콜릿',
        name: '민트 초콜릿 칩',
        img: process.env.PUBLIC_URL + '/images/ice_cream27.png',
    },
    {
        id: 28,
        category: '과일',
        name: '사랑에 빠진 딸기',
        img: process.env.PUBLIC_URL + '/images/ice_cream28.png',
    },
    {
        id: 29,
        category: '치즈 / 크림',
        name: '이상한 나라의 솜사탕',
        img: process.env.PUBLIC_URL + '/images/ice_cream29.png',
    },
    {
        id: 30,
        category: '디저트',
        name: '바닐라',
        img: process.env.PUBLIC_URL + '/images/ice_cream30.png',
    },
    {
        id: 31,
        category: '초콜릿',
        name: '쿠키 앤 카라멜',
        img: process.env.PUBLIC_URL + '/images/ice_cream31.png',
    },
    {
        id: 32,
        category: '견과 / 커피 / 티',
        name: '피스타치오 아몬드',
        img: process.env.PUBLIC_URL + '/images/ice_cream32.png',
    },
    {
        id: 33,
        category: '견과 / 커피 / 티',
        name: '그린티',
        img: process.env.PUBLIC_URL + '/images/ice_cream33.png',
    },
    {
        id: 34,
        category: '초콜릿',
        name: '초콜릿',
        img: process.env.PUBLIC_URL + '/images/ice_cream34.png',
    },
    {
        id: 35,
        category: '샤베트 / 요거트',
        name: '31요거트',
        img: process.env.PUBLIC_URL + '/images/ice_cream35.png',
    },
    {
        id: 36,
        category: '초콜릿',
        name: '아몬드 봉봉',
        img: process.env.PUBLIC_URL + '/images/ice_cream36.png',
    },
    {
        id: 37,
        category: '견과 / 커피 / 티',
        name: '자모카 아몬드 훠지',
        img: process.env.PUBLIC_URL + '/images/ice_cream37.png',
    },
]

export default iceCream;